import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { combineLatest } from 'rxjs';
import { BaseUtenteComponent } from 'src/app/components/base-utente/base-utente.component';
import { MessageData, MessageLevel, MessageMode } from '../../models/message';
import { TranslateItemPipe } from '../../pipes/translate-item.pipe';
import { AppManagerService } from '../../services/app-manager.service';
import { Resources, TranslateService } from '../../services/translate.service';
import { safeTakeUntilDestroyed } from '../../utils/util';

@Component({
  selector: 'app-message-data',
  templateUrl: './message-data.component.html',
  styles: ``,
  standalone: true,
  imports: [ButtonModule, DialogModule, NgIf, NgSwitch, NgSwitchCase, TranslateItemPipe]
})
export class MessageDataComponent extends BaseUtenteComponent {
  messageMode = MessageMode;
  messageLevel = MessageLevel;
  messageData: MessageData;
  translateItems: Resources;
  visible: boolean = false;

  constructor(
    override readonly appManagerService: AppManagerService,
    private readonly translateService: TranslateService
  ) {
    super(appManagerService);
  }

  onUtenteInit(): void {
    combineLatest([this.appManagerService.messageData$, this.translateService.translatedItems$(['generic.', 'error.'])])
      .pipe(safeTakeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ([messageData, translateItems]) => {
          if (messageData && translateItems) {
            this.messageData = messageData;
            this.translateItems = translateItems;
            this.visible = true;
          }
        }
      });
  }

  close(): void {
    this.visible = false;
    this.messageData.notify('close');
  }

  ko(): void {
    if (this.messageData.hEventKo) {
      this.messageData.hEventKo();
    }

    this.visible = false;
    this.messageData.notify('ko');
  }

  ok(): void {
    if (this.messageData.hEventOk) {
      this.messageData.hEventOk();
    }

    this.visible = false;
    this.messageData.notify('ok');
  }
}
